import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Button, Input } from '@/ui';

export const StyledWrapper = styled.div`
  flex-grow: 1;
  display: flex;
`;

export const StyledInput = styled(Input)<{
  $hidden?: boolean;
}>`
  &&& .ant-input-wrapper {
    & .ant-input {
      height: 3rem;
      background: ${COLORS.GREY_BRIGHT} !important;
      color: ${COLORS.BLACK};
      border-radius: ${({ $hidden }) => ($hidden ? '1rem' : '1rem 0 0 1rem')};
      padding-inline: 1.5rem;
      border: 1px solid ${COLORS.GREY};
      border-right: ${({ $hidden }) => `1px solid ${$hidden ? COLORS.BLACK : 'transparent'}`};

      &::placeholder {
        color: inherit;
        font-style: italic;
        ${pickThemeFontStyles('14', '20')};
      }

      &:focus {
        border: 1px solid ${COLORS.ORANGE_PRIMARY};
        border-right: 0;
        box-shadow: none;
      }
    }

    & .ant-input-group-addon {
      width: 4rem;
      border-radius: 0 1rem 1rem 0;
      background-color: ${COLORS.ORANGE_PRIMARY};
      border-left: 0;
      border: 0;
      padding: 0;
      overflow: hidden;
    }

    &&& .ant-input-affix-wrapper {
      background: ${COLORS.WHITE_SMOKE};
      color: ${COLORS.WHITE_SMOKE};
      border-radius: 1rem 0 0 1rem;
    }

    .ant-input-suffix {
      background-color: transparent;
    }
  }
`;

export const StyledAddonButton = styled(Button)`
  width: 4rem;
  padding: 0 !important;
  border-radius: 1rem !important;
  &&& .anticon {
    margin-right: 2rem;
    font-size: 1rem !important;
    display: flex;
    justify-content: center;
    align-items: center;

    .svg {
      width: 1.5rem;
      height: 1.5rem;
    }

    &:not(.ant-btn-loading) {
      color: ${COLORS.BLACK_PRIMARY};
    }
  }

  &&&&:disabled {
    background-color: transparent;
  }

  &&& .anticon.anticon-loading {
    color: ${COLORS.GREY_SUVA};
  }
`;
